import { useFlags } from "launchdarkly-react-client-sdk";

export const useV2Devices = () => {
  const { rolloutV2DevicesForSimulator } = useFlags();
  return rolloutV2DevicesForSimulator;
};
